import { EOWValidateException } from "OW.Remoting/Basic/OWExceptions";
import { IOWObject } from "OW.Remoting/Remoting/DataTypes/IOWObject";
import { OWObjectList } from "OW.Remoting/Remoting/DataTypes/OWObjectList";
import { IParticipantBase, IWorkflowMenuItem } from "OW.Remoting/Remoting/IWorkflowManager";
import { OWManager } from "OW.Remoting/Remoting/OWManager";
import { ErrorHandler } from "UI/Errors";
import { ActionContext } from "UI/UI.Controls/Actions/IAction";
import { UIManager } from "../../UIManager";
import { IValidatableMasterableFrame, IWorkflowMasterableFrame } from "../Frames/FrameInterfaces";
import { IFrame } from "../IFrame";
import { SharedMethods } from "../SharedMethods";
import { WindowedDetailFrame } from "../WindowedDetailFrame";
import { ActionSharedMethods } from "./ActionSharedMethods";
import { WFAction } from "./WFAction";

export class WFMultiAction extends WFAction {
    public override get context(): ActionContext {
        return ActionContext.frameAction;
    }

    private _objectList: OWObjectList = new OWObjectList();
    public get objectList(): OWObjectList {
        return this._objectList;
    }

    public set objectList(value: OWObjectList) {
        this._objectList = value;
    }

    constructor(wfAction: IWorkflowMenuItem, owner: IFrame, objectList: OWObjectList) {
        super(wfAction, owner);

        this.visible = true;
        this._objectList = objectList;
    }

    /**
     * Spusteni WF akce
     */
    protected override async _executeWfAction(_object: IOWObject, _wfMenuItem: IWorkflowMenuItem, refreshOwner: boolean = true, paramFormObject?: IOWObject, participants?: IParticipantBase[]): Promise<void> {
        try {
            UIManager.instance.showLoader();

            const result = await OWManager.objectListWFActionExecute(this.objectList, this.wfMenuItem.ID, participants, paramFormObject?.instanceID ?? undefined, this._getRequestContext());

            //Pokud během obj.WFActionExecute(...) nastal EOWLongTransactionTimeOut (metoda byla pouštěna v režimu dlouhé transakci a jeji práce se neukončila v zadaném termínu)
            //metoda vrací false, a zobrazuje se informační okno
            if (result.isInLongTransaction) {
                ActionSharedMethods.checkMethodResult(result);

                return null;
            }

            if (refreshOwner) {
                if (this.owner) {
                    if (this.owner instanceof IWorkflowMasterableFrame || this.owner instanceof WindowedDetailFrame) {
                        this.owner.reloadWFItems(); // po provedení akce se znovu načte WF, protože mohlo dojít ke změně jeho stavu

                        await this.owner.refreshData(false);
                    }
                }
            }
            UIManager.instance.showResultMessages(result.messages);
        } catch (error) {
            if (error instanceof EOWValidateException && this.owner instanceof IValidatableMasterableFrame) {
                const objects = await this.objectList.getObjects();
                await SharedMethods.handleValidationErrors(objects, error, this.owner);
            } else {
                ErrorHandler.instance.handleError(error);
            }
        } finally {
            UIManager.instance.hideLoader();
        }
    }
}
